import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { loginGuestAccount } from "../../store/actions";
import LoaderAnimation from "../../components/UI/LoaderAnimation/LoaderAnimation.tsx";

interface InvitePageProps {
  loginGuestAccount: () => Promise<any>;
}

const InvitePage: React.FC<InvitePageProps> = ({ loginGuestAccount }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const redirectParam = searchParams.get("redirect");
  const redirect =
    redirectParam && redirectParam.startsWith("/") ? redirectParam : "/dashboard";

  useEffect(() => {
    loginGuestAccount()
      .then(() => navigate(redirect))
      .catch((error) => console.error("Login error:", error));
  }, [loginGuestAccount, navigate, redirect]);

  return <LoaderAnimation isActive={true} type="invite" />;
};

export default connect(null, { loginGuestAccount })(InvitePage);
